import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "offcanvas-body" }
const _hoisted_2 = { class: "offcanvas-footer" }

import { computed, onMounted, ref } from "vue";
import { toTypedSchema } from "@vee-validate/zod";
import { useForm } from "vee-validate";
import { useVeeField } from "@/composables/useVeeField";
import { specialtiesSchema } from "@/schemas/profile";
import { useSessionStore } from "@/store/useSessionStore";
import { EventBus, EventBusNames } from "@/utils/EventBus";
import { useOccupationAreas } from "@/composables/useSettings";
import { useUpdateUser } from "@/composables/useAuth";


export default /*#__PURE__*/_defineComponent({
  __name: 'Specialties',
  setup(__props) {

const sessionStore = useSessionStore();
const session = computed(() => sessionStore.session);
const submitting = ref(false);

const { occupationAreas: allOccupations, isPending } = useOccupationAreas();

const { handleSubmit, meta, resetForm } = useForm({
  validationSchema: toTypedSchema(specialtiesSchema),
  initialValues: { occupation_areas: [] },
});

const occupationAreasModel = useVeeField<number[]>("occupation_areas");

onMounted(() => {
  resetForm({
    values: {
      occupation_areas:
        session.value?.occupations.map((o: any) => o.occupation_area_id) ?? [],
    },
  });
});

const occupationOptions = computed(() =>
  allOccupations.value.map((o) => ({
    ...o,
    name: o.title,
    selected: occupationAreasModel.$model.includes(o.id),
  })),
);

const { mutateAsync: updateUser } = useUpdateUser();

function handleSelect() {
  if (occupationAreasModel.$model.length > 6) {
    alert("Você só pode selecionar 6 especialidades");
    occupationAreasModel.$model.pop();
  }
}

const submit = handleSubmit(async (values) => {
  try {
    submitting.value = true;
    await updateUser({
      id: session.value!.id,
      occupation_areas: values.occupation_areas,
    });
    EventBus.$emit(EventBusNames.SHOW_TOAST, {
      title: "Alterações feitas",
      msg: "Suas informações foram salvas",
    });
  } catch (error) {
    console.error(error);
  } finally {
    submitting.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_LoadingContainer = _resolveComponent("LoadingContainer")!
  const _component_CheckboxInput = _resolveComponent("CheckboxInput")!
  const _component_FormButton = _resolveComponent("FormButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_unref(isPending))
        ? (_openBlock(), _createBlock(_component_LoadingContainer, { key: 0 }))
        : (_openBlock(), _createBlock(_component_CheckboxInput, {
            key: 1,
            options: occupationOptions.value,
            model: _unref(occupationAreasModel),
            onOnChange: handleSelect
          }, null, 8, ["options", "model"]))
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_FormButton, {
        marginVertical: false,
        label: "Concluir",
        loading: submitting.value,
        onOnClick: _unref(submit),
        disabled: !_unref(meta).valid
      }, null, 8, ["loading", "onOnClick", "disabled"])
    ])
  ], 64))
}
}

})